import React from "react";

const LinkArrayInput = ({ links, onChange }) => {
  const handleAdd = () => onChange([...links, { label: "", url: "" }]);

  const handleRemove = (index) =>
    onChange(links.filter((_, i) => i !== index));

  const handleChange = (index, field, value) => {
    const updated = links.map((link, i) =>
      i === index ? { ...link, [field]: value } : link,
    );
    onChange(updated);
  };

  return (
    <div className="linkArrayInput">
      {links.map((link, i) => (
        <div key={i} className="linkArrayInput__item">
          <input
            type="text"
            className="linkArrayInput__label"
            placeholder="ラベル（例: 公式サイト）"
            maxLength={50}
            value={link.label}
            onChange={(e) => handleChange(i, "label", e.target.value)}
          />
          <input
            type="url"
            className="linkArrayInput__url"
            placeholder="https://..."
            maxLength={500}
            value={link.url}
            onChange={(e) => handleChange(i, "url", e.target.value)}
          />
          <button
            type="button"
            className="linkArrayInput__remove"
            onClick={() => handleRemove(i)}
          >
            削除
          </button>
        </div>
      ))}
      {links.length < 10 && (
        <button
          type="button"
          className="linkArrayInput__add"
          onClick={handleAdd}
        >
          + URLを追加
        </button>
      )}
    </div>
  );
};

export default LinkArrayInput;
